// --- Styles ---
import '@fortawesome/fontawesome-free/css/all.min.css';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ApplicantJobApplication from "./pages/MyJobApplication/ApplicantJobApplication";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { lazyRetry as lazy } from "./utils/lazyRetry";

// --- Layouts (Static import is usually better for core layouts) ---
import AppLayout from "./layout/AppLayout";
import ApplicantLayout from "./layout/ApplicantLayout";
import WarrantyClaim from './pages/Company/Warranty-Claim/home';

// --- Lazy loaded Pages ---
const Home = lazy(() => import("./pages/Dashboard/Home"));
const Products = lazy(() => import("./pages/Products/home"));
const Franchise = lazy(() => import("./pages/Franchis/home"));
const TermsAndConditions = lazy(() => import("./pages/Company/Team-and-Conditions/home"));
const PrivacyPolicy = lazy(() => import("./pages/Company/Privacy-Policy/home"));
const WarrantyPolicy = lazy(() => import("./pages/Company/Warranty-Policy/home"));
const MeetOurTeamHeros = lazy(() => import("./pages/Company/Meet-Our-Team/home"));
const ContactUsComponent = lazy(() => import("./pages/Company/Contact-Us/home"));
const FaqsPage = lazy(() => import("./pages/Company/Faqs/home"));
const Disclaimer = lazy(() => import("./pages/Company/Disclaimer/home"));
const About = lazy(() => import("./pages/Company/About/home"));
const OffersToday = lazy(() => import("./pages/Offers/home"));
const Live = lazy(() => import("./pages/Live/Live/home"));
const LatestNews = lazy(() => import("./pages/Live/Latest-news/home"));
const JobsPage = lazy(() => import("./pages/Jobs/JobsPage"));
const ApplicantDashboard = lazy(() => import("./pages/Dashboard/ApplicantDashboard"));
const ApplicantProfile = lazy(() => import("./pages/ApplicantProfile/profile"));
const JobApplicationDetail = lazy(() => import("./pages/Jobs/components/JobApplicationDetail"));
const MyOrderPage = lazy(() => import("./pages/MyOrder/MyOrderPage"));
const NotFound = lazy(() => import("./pages/OtherPage/NotFound"));
const BookingRepairServicePage = lazy(() => import("./pages/BookingRepair/ServicePage"));
const ModelSelectionPage = lazy(() => import("./pages/BookingRepair/ModelSelectionPage"));
const ColorSelectionPage = lazy(() => import("./pages/BookingRepair/ColorSelectionPage"));

// --- Loading Component ---
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[60vh]">
    <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const ApplicantSettings = () => {
  return <h1 className="text-xl font-semibold p-6 text-center">Account Settings Coming Soon</h1>;
};

export default function App() {
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  };

  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Main Layout */}
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Home />} />
            <Route path="products/dashboard" element={<Products />} />
            <Route path="/jobs/:jobSlug" element={<JobApplicationDetail />} />

            <Route
              path="/applicant/*"
              element={
                <ApplicantLayout onLogout={handleLogout} />
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<ApplicantDashboard />} />
              <Route path="explore" element={<JobsPage onlyJobList={true} />} />
              <Route path="applied/:id?" element={<ApplicantJobApplication />} />
              {/* <Route path="order" element={<MyOrderPage />} /> */}
              <Route path="order/:id?" element={<MyOrderPage />} />
              <Route path="profile" element={<ApplicantProfile />} />
              <Route path="settings/account" element={<ApplicantSettings />} />
            </Route>

            {/* General Routes */}
            <Route path="franchise" element={<Franchise />} />
            <Route path="company/terms" element={<TermsAndConditions />} />
            <Route path="company/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="company/warranty-policy" element={<WarrantyPolicy />} />
            <Route path="company/warranty-claim" element={<WarrantyClaim />} />
            <Route path="company/team" element={<MeetOurTeamHeros />} />
            <Route path="company/contact" element={<ContactUsComponent />} />
            <Route path="company/faqs" element={<FaqsPage />} />
            <Route path="company/disclaimer" element={<Disclaimer />} />
            <Route path="company/about-us" element={<About />} />
            <Route path="offers" element={<OffersToday />} />
            <Route path="jobs" element={<JobsPage />} />
            <Route path="booking-repair/:serviceName" element={<BookingRepairServicePage />} />
            <Route path="booking-repair/:serviceName/:brandName" element={<ModelSelectionPage />} />
            <Route path="booking-repair/:serviceName/:brandName/:modelName" element={<ColorSelectionPage />} />
            <Route path="live" element={<Live />} />
            <Route path="live/latest-news" element={<LatestNews />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}
